import {Injectable} from '@angular/core';
import {environment} from "../environments/environment";
import {Routes} from "@angular/router";
import {AuthComponent} from "./@core/auth/auth.component";
import {AuthGuardService} from "./@core/guards/auth-guard.service";

const standardRoutes: Routes = [
  {
    path: 'login',
    component: AuthComponent,
  },
  {
    path: '',
    loadChildren: () => import('../app/@modules/+start-page/start-page.module').then(m => m.StartPageModule),
    canActivate: [AuthGuardService],
  },
  {
    path: '',
    redirectTo: '/',
    pathMatch: 'full',
  },
];

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  private configRoutesSettings: Routes;

  async loadConfig(): Promise<any> {
    switch (environment.projectName) {
      case 'CSGOFAST':
        return await import('../config/csgofastConfig').then(c => this.configRoutesSettings = c.csgoFastRoutes);
      case 'HLTV':
        return await import('../config/hltvConfig').then(c => this.configRoutesSettings = c.hltvRoutes);
      default:
        return []
    }
  }

  get settings() {
    return [...standardRoutes, ...this.configRoutesSettings]
  }
}
